var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { isArray } from '../_util/is';
export var renderElem = function (children, props) {
    var results = React.Children.map(children, function (item, index) {
        if (!item || !item.props) {
            return item;
        }
        if (item.key && item.type && item.type.menuType) {
            return React.cloneElement(item, __assign(__assign({}, props), { _key: item.key }));
        }
        if (item.props.children && !item.type.menuType) {
            var otherProps = typeof item.type === 'string' ? {} : props;
            return React.cloneElement(item, __assign(__assign({}, otherProps), { _key: item.key, children: renderElem(item.props.children, props) }));
        }
        return typeof item.type === 'string'
            ? item
            : React.cloneElement(item, __assign(__assign({}, props), { _key: item.key || "$menu-" + index }));
    });
    if (isArray(results) && results.length === 1) {
        return results[0];
    }
    return results;
};
export function isChildrenSelected(children, keys) {
    var find = false;
    function loop(_children) {
        if (!_children || find) {
            return;
        }
        React.Children.forEach(_children, function (c) {
            if (c && c.props && c.type && !find) {
                var menuType = c.type.menuType;
                var selectable = c.props.selectable;
                if (menuType === 'MenuItem') {
                    find = keys.indexOf(c.key) !== -1;
                }
                else if (menuType === 'SubMenu' && selectable) {
                    find = keys.indexOf(c.key) !== -1;
                }
                if (!find && c.props.children) {
                    loop(c.props.children);
                }
            }
        });
    }
    loop(children);
    return find;
}
